export default __webpack_public_path__ + "static/media/FeverLand_09.f95c9056.png";